{
  "_comment": "Outbound links the user clicks (opened in a new tab, nothing of the user's in them), kept out of the code like src/params/sources.json so src/smoke.test.ts still forbids remote URLs in .ts files. cloudflareNel: the privacy page's hosting text, the error report link (Matt GO 2026-10-23, option a; src/ui/linkText.ts). googleSearch: the too-big photo refusal (src/ui/photoTooLarge.ts), followed by a fixed translated query (Matt, 2026-10-22 17:13). opening: the sources of design D's opening page (src/ui/flowD/opening.ts; MATT GO 2026-10-23 00:56 and 00:58: every figure links its source; URLs as read in magia-mailbox/research/landing-stats-2026-10-23.md 'Source check', 2026-10-23); companies: the refund companies' own price pages (Matt 2026-10-23 02:02, FINAL fee text), names as i18n keys openingD.co.<key>; industry: two industry articles on the usual range, labels openingD.src.<key>.",
  "cloudflareNel": "https://developers.cloudflare.com/network-error-logging/",
  "googleSearch": "https://www.google.com/search?q=",
  "opening": {
    "comptroller": "https://library.mevaker.gov.il/sites/DigitalLibrary/Documents/2021/72A-2/2021-72A-Part2-306-Hatavot-Mas-Taktzir.pdf",
    "walla": "https://finance.walla.co.il/item/3555312",
    "ordinance": "https://he.wikisource.org/wiki/%D7%A4%D7%A7%D7%95%D7%93%D7%AA_%D7%9E%D7%A1_%D7%94%D7%9B%D7%A0%D7%A1%D7%94",
    "booklet": "https://www.gov.il/BlobFolder/generalpage/income-tax-guide-knowyourright/he/Guides_IncomeTax_da-2025.pdf",
    "refundService": "https://www.gov.il/he/service/itc135",
    "companies": [
      {
        "key": "finupp",
        "url": "https://www.finupp.meitavdash.co.il/pricing"
      },
      {
        "key": "kravi",
        "url": "https://www.kravi.co.il/backmas/"
      },
      {
        "key": "hechzer",
        "url": "https://hechzerplus.co.il/questions/%D7%9B%D7%9E%D7%94-%D7%A2%D7%95%D7%9C%D7%94-%D7%94%D7%97%D7%96%D7%A8-%D7%9E%D7%A1/"
      }
    ],
    "industry": [
      {
        "key": "mass",
        "url": "https://mass.co.il/kama-ole-hachzer-mas/"
      },
      {
        "key": "abro",
        "url": "https://abro-law.co.il/tax-refund-fees/"
      }
    ]
  }
}
